import {
  fetchGeocodedForSearch,
  TGeocodedForSearchResponse,
  TGeocodedForSearchRequest,
} from 'shared/repositories/geo/v1/geocoded-for-search';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IGeocodeForSearchResponse } from 'shared/types/geoSuggest';

export const geocodeForSearch = async (
  { httpApi }: IApplicationContext,
  parameters: TGeocodedForSearchRequest,
): Promise<IGeocodeForSearchResponse> => {
  const { response }: TGeocodedForSearchResponse = await fetchGeocodedForSearch({
    httpApi,
    parameters,
  });

  return response as IGeocodeForSearchResponse;
};
